import { useAppContext } from "@/context/Context";
import DarkSwitch from "./dark-switch";

/**
 * Componente Layout que renderiza el interruptor de tema.
 *
 * @returns {JSX.Element} - Elemento que muestra el DarkSwitch.
 */
const Layout = () => {
  const { isLightTheme, toggleTheme } = useAppContext();

  return <DarkSwitch isLight={isLightTheme} switchTheme={toggleTheme} />;
};

export default Layout;
